import UserReviews from '../LandingPage/components/UserReviews';
import { IntegrationsList } from '../../routes/_public.chatgpt-for-microsoft-word';
import PromptsListing from '../LandingPromptsListing';

function Breadcrumbs() {
    return (
        <div className='py-4 bg-white'>
            <div className='px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl'>
                <nav>
                    <ul className='flex items-center space-x-3'>
                        <li>
                            <a
                                href='/'
                                title='AI Perfect Assistant - Home Page'
                                className='text-gray-500 hover:text-gray-900'>
                                <svg
                                    className='w-5 h-5'
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    stroke='currentColor'
                                    strokeWidth='2'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
                                    />
                                </svg>
                            </a>
                        </li>

                        <li className='flex items-center space-x-3'>
                            <svg
                                className='flex-shrink-0 w-4 h-4 text-gray-500'
                                xmlns='http://www.w3.org/2000/svg'
                                fill='none'
                                viewBox='0 0 24 24'
                                stroke='currentColor'
                                strokeWidth='2'>
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    d='M9 5l7 7-7 7'
                                />
                            </svg>

                            <a
                                href='/tools'
                                title='Free AI Tools'
                                className='text-sm font-medium text-gray-500 hover:text-gray-900'>
                                {' '}
                                Free AI Tools{' '}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default function Index({ title, description, prompts }) {
    return (
        <>
            <Breadcrumbs />
            <PromptsListing
                title={title}
                description={description || '100% Free Ai Tools. No Login.'}
                prompts={prompts}
            />
            <IntegrationsList title='Add ChatGPT into' />
        </>
    );
}
